<template>
  <div>
    <h3 class="title">Follow Up</h3>
    <div class="ui segment" v-if="!!followUp && followUp.name">
      <h5>{{ followUp.name }}</h5>
      <p>{{ followUp.result }}</p>
    </div>
    <p v-else>No follow up</p>
  </div>
</template>

<script>
export default {
  props: {
    followUp: { type: Object, required: false }
  }
};
</script>

<style scoped>
.title {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/visit_history_components/VisitFollowUp.vue